import React from 'react';
import PageLayout from 'src/common/components/PageLayout';
import FormSession from './FormSession';

const NewSession2 = () => {
	return (
		<PageLayout>
			<FormSession isNew={true} />
		</PageLayout>
	);
};

export default NewSession2;
